import { toast } from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import { airecord } from "../apis"; 
const { GET_ALL_RECORD_API, GET_RECORD_BY_ID_API,UPDATE_REPORT_API } = airecord;

// Fetch all AI records
export async function getAllAIRecords() {
  try {
    const response = await apiConnector("GET", GET_ALL_RECORD_API);

    if (!response.data.success) throw new Error(response.data.message);

   // console.log("All AI Records:", response.data.data);
    return response.data.data;
  } catch (error) {
    console.error("Failed to fetch AI records:", error);
    toast.error(error.message || "Failed to fetch AI records");
    return null;
  }
}

// Fetch AI record by patient ID
export async function getAIRecordById(id) {
  try {
    const response = await apiConnector("GET", GET_RECORD_BY_ID_API(id));

    if (!response.data.success) throw new Error(response.data.message);

  //  console.log("AI Record:", response.data.data);
    return response.data.data;
  } catch (error) {
    console.error(`Failed to fetch AI record for patient ${id}:`, error);
    toast.error(error.message || "Failed to fetch AI record");
    return null;
  }
}

// Add or update doctor report
export async function addDoctorReport({ patient_id, consultation_id, doctor_report }) {
    // console.log(patient_id, consultation_id, doctor_report)
    // console.log("api",UPDATE_REPORT_API)
  try {
    const response = await apiConnector("PUT", UPDATE_REPORT_API, {
      patient_id,
      consultation_id,
      doctor_report,
    });

    if (!response.data.success) throw new Error(response.data.message);

    //console.log("Updated AI Record:", response.data.data);
    toast.success("Doctor report added successfully");
    return response.data.data;
  } catch (error) {
    console.error("Failed to add doctor report:", error);
    toast.error(error.message || "Failed to add doctor report");
    return null;
  }
}
